import { UserWithModuleSettings } from "@models";
import React from "react";

type UsersListContextValue = {
	users: UserWithModuleSettings[];
	triggerRefresh: () => void;
};

export default React.createContext<UsersListContextValue>({
	users: [],
	triggerRefresh: () => {},
});
